<template>
    <div>
        <div :class="['title', smallGap ? 'mb-2 small' : 'mb-3']">
            {{ trans('passwords.requirements') }}:
        </div>
        <div :class="['d-flex flex-column', smallGap ? 'gap-1' : 'gap-3']">
            <div v-for="(rule, key) in dynamicRules" :key="key" class="d-flex gap-2 align-items-start">
                <i :class="['fi', rule.isValid ? 'fi-rr-check text-green' : 'fi-rr-bullet text-gray-1000']"></i>
                <label :class="[rule.isValid ? 'text-dark-green' : 'text-gray-1000']">{{ rule.message }}</label>
            </div>
            <div class="d-flex gap-2 align-items-start" v-if="passwordsMatch !== null">
                <i :class="['fi', passwordsMatch ? 'fi-rr-check text-green' : 'fi-rr-bullet text-gray-1000']"></i>
                <label :class="[passwordsMatch ? 'text-dark-green' : 'text-gray-1000']">
                    {{ trans('passwords.validation.password_should_match') }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import {userPasswordRules} from "../../services/PasswordService";

export default {
    name: "PasswordRulesValidator",
    props: {
        validate: {
            type: String,
            required: true,
            default: "",
        },
        passwordsMatch: {
            type: Boolean|null,
            required: false,
            default: null,
        },
        smallGap: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            password: "",
            dynamicRules: {},
            passwordRules: userPasswordRules(),
        };
    },
    watch: {
        validate() {
            this.password = this.validate;
            this.validatePassword();
        },
    },
    mounted() {
        this.initializeRules();
    },
    methods: {
        initializeRules() {
            this.dynamicRules = this.passwordRules.reduce((acc, rule) => {
                acc[rule.key] = { isValid: false, message: rule.message, regex: rule.regex };
                return acc;
            }, {});
        },
        validatePassword() {
            Object.keys(this.dynamicRules).forEach((key) => {
                const rule = this.dynamicRules[key];
                rule.isValid = rule.regex.test(this.password);
            });

            const allValid = Object.values(this.dynamicRules).every((rule) => rule.isValid);
            this.$emit("input", allValid);
        },
    },
};
</script>
